import React from 'react';
import { Field, reduxForm } from 'redux-form';

import '../../assets/css/dialog.css';
import '../../assets/css/forms.css';
import renderFieldNormal from '../shared/RenderFieldNormal';
import { required, passwordValidation } from '../../helpers';
import { Loader } from '../shared/TileLoader';

let NewPasswordForm = ({ handleSubmit, onSubmit, submitting, onReturnKeyPress, isLoading }) => {
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {isLoading && <Loader />}
      <fieldset className="login-user forgot-password">
        <Field
          component={renderFieldNormal}
          onReturnKeyPress={onReturnKeyPress}
          type="password"
          placeholder="Enter your new password"
          name="password"
          label="New Password"
          validate={[required, passwordValidation]}
          autoFocus={true}
          showError={true}
        />
      </fieldset>
      <button type="submit" className="button-primary" disabled={submitting}>
        SUBMIT NEW PASSWORD
      </button>
    </form>
  );
};

NewPasswordForm = reduxForm({
  // a unique name for the form
  form: 'NewPasswordForm',
})(NewPasswordForm);

export default NewPasswordForm;
